import { Box, Button, Typography, Modal, Slide, Stack, Tooltip } from "@mui/material"
import {RocketLaunchOutlined as RocketLaunchOutlinedIcon, Close as CloseIcon, CheckCircle as CheckCirleIcon }from '@mui/icons-material';
import { useState, useEffect, useContext } from "react";
import LinearProgress from '@mui/material/LinearProgress';
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { ToolContext } from "../../../../core/context/ToolContext";
// import { VM } from "../../../../core/VM";
import { rqx } from "../../../../core/request/API";
import { env } from "../../../../core/Env";
import { useShowRealProperty } from "../../global/GlobalFunctions";

export const StartHere = () =>{

    const [progress, setProgress] = useState(0)
    const nav = useHistory()
	const showRP = useShowRealProperty()

    const {personalization_state, tool_state} = useContext(ToolContext)
    const {walkthrough, startHere, openBankForm, bankAgreed, selected} = personalization_state
    // const {__SESSION} = tool_state

    const user_id = parseInt(atob(tool_state.__SESSION.data.ainfo.aid).split('_', 2)[1]);
	const company_id = tool_state.__SESSION.data.uaccess[0].company_id
	// console.log(tool_state.__SESSION.data.uaccess[0].company_id)
    // const role = __SESSION.data.uaccess[0].role_name
    // const view = VM()

	const contactType = selected.data?.some(v => v.id === 1) ? 'product' : selected.data?.some(v => v.id === 2) ? 'booking' : showRP ? 'real-property' : selected.data?.some(v => v.id === 4) ? 'training' : 'membership'

    const handleClick = (name)=>{
		if (name === 'bankDetails') openBankForm.set(true)
        walkthrough.set((prev) => ({...prev, [name]:true}))
		startHere.set((p) => ({ ...p, show: false}))
    }
    
    const task = [
        {
            task: "Creative Brief", // FOR ALL INDUSTRY
            description : "Create 1 creative brief of your campaign",
            done: startHere.data.tasks?.creative_brief,
            path: "/campaign/creative-brief?mode=list", 
			condition: false, 
            setter: ()=>{handleClick('creativeBrief')}
        },
		...selected.data?.some(v => v.id === 1) ? [{
			task: "Promo Page", // FOR PRODUCT INDUSTRY
			description : "Create 1 your first product promo page.", 
			done: startHere.data.tasks?.promo_page,
			path: "/campaign/promo?type=product",
			condition: false, 
			setter: ()=>{handleClick('productPromoPage')}
		}]: [],
		...selected.data?.some(v => v.id === 2) ? [{
			task: "Booking Promo Page", // FOR BOOKING INDUSTRY
			description : "Create 1 your first booking promo page.", 
			done: startHere.data.tasks?.booking_promo_page,
			path: "/campaign/promo?type=service",
			condition: false, 
			setter: ()=>{handleClick('bookingPromoPage')}
		}]: [],
		...selected.data?.some(v => v.id === 4) ? [{
			task: "Training Setup", // FOR TRAINING INDUSTRY
			description : "Setup your training for free or with pay.", 
			done: startHere.data.tasks?.training_setup,
			path: "/setup/training",
			condition: false, 
			setter: ()=>{handleClick('setupTraining')}
		}]: [],
		...selected.data?.some(v => v.id === 4) ? [{
			task: "Training Poster", // FOR TRAINING INDUSTRY
			description : "Setup your training poster.", 
			done: startHere.data.tasks?.training_poster,
			path: "/campaign/poster?type=training",
			condition: false, 
			setter: ()=>{handleClick('posterTraining')}
		}]: [],
		...showRP ? [{
			task: "My Real Property", // REAL PROPERTY
			description : "Setup your property for sale or rent.", 
			done: startHere.data.tasks?.my_real_property,
			path: "/setup/real-property?type=property-listing",
			condition: false, 
			setter: ()=>{handleClick('realProperty')}
		}]: [],
		...showRP ? [{
			task: "Requested Real Property", // REAL PROPERTY
			description : "View and Update your property request for listing.", 
			done: startHere.data.tasks?.requested_real_property?.done,
			path: "/setup/real-property?type=requested-listing",
			condition: true,
			isConditionMet: startHere.data.tasks?.requested_real_property?.enabled,
			preReq: ['If with property request for Listing'],
			setter: ()=>{handleClick('requestedRealProperty')}
		}]: [],
		{
			task: "Call Recording", // FOR ALL INDUSTRY
			description : "Record 5 call details in your call monitoring.", 
			done: startHere.data.tasks?.call_recording?.done, 
			path: "/campaign/call-monitoring?type=record", 
			condition: false,
			inProgress: startHere.data.tasks?.call_recording?.in_progress, 
			setter: ()=>{handleClick('callRecording')}
		},
		{
			task: "Add Contacts", // FOR ALL INDUSTRY
			description : "Setup 5 clients in your contacts.", 
			done: startHere.data.tasks?.contacts?.done, 
			path: `/setup/contacts?subft=${contactType}`,
			condition: false,
			inProgress: startHere.data.tasks?.call_recording?.in_progress, 
			setter: ()=>{handleClick('contact')}
		},
		{
			task: "Facebook Connect", // FOR ALL INDUSTRY
			description : "Connect your Facebook account to HRC to automatically view your Facebook Insights.", 
			done: startHere.data.tasks?.facebook_connect, 
			path: "/social-media-insight?state=facebook",
			condition: false, 
			setter: ()=>{handleClick('socialMedia')}
		},
		{
			task: "Company Setup", // FOR ALL INDUSTRY
			description : "Setup your Company and bank details.", 
			done: bankAgreed?.data, 
			path: "", 
			condition: false, 
			setter: ()=>{handleClick('bankDetails')}
		},
		...selected.data?.some(v => v.id === 1) ? [{
			task: "Received Orders", // FOR PRODUCT INDUSTRY
			description : "View and update your orders under the “Received” status.", 
			done: startHere.data.tasks?.received_orders?.done, 
			path: "/sales/product?tab=received", 
			condition: true,
			isConditionMet: startHere.data.tasks?.received_orders?.enabled,
			preReq: ['If with Orders in Received Status'],
			// setter: ()=>{handleClick('productReceived')}
			setter: ()=>{handleClick('onboardingSalesProduct')}
		}]: [],
		...selected.data?.some(v => v.id === 1) ? [{
			task: "Preparing Orders", // FOR PRODUCT INDUSTRY
			description : "View and update your orders under the “Preparing” status.", 
			done: startHere.data.tasks?.preparing_orders?.done, 
			path: "/sales/product?tab=preparing", 
			condition: true,
			isConditionMet: startHere.data.tasks?.preparing_orders?.enabled,
			preReq: ['If with Orders in Preparing Status'],
			setter: ()=>{handleClick('productPreparing')}
		}]: [],
		...selected.data?.some(v => v.id === 1) ? [{
			task: "Shipped Orders", // FOR PRODUCT INDUSTRY
			description : "View and update your orders under the “Shipped” status.", 
			done: startHere.data.tasks?.shipped_orders?.done, 
			path: "/sales/product?tab=shipped", 
			condition: true,
			isConditionMet: startHere.data.tasks?.shipped_orders?.enabled,
			preReq: ['If with Orders in Shipped Status'],
			setter: ()=>{handleClick('productShipped')}
		}]: [],
		// {
		// 	task: "Delivered Orders", 
		// 	description : "View your orders under the “Delivered” status.", 
		// 	done: startHere.data.tasks?.delivered_orders,  
		// 	path: "/sales/product?tab=delivered", 
		// 	condition: false, 
		// 	setter: ()=>{handleClick('productDelivered')}
		// },
		// {
		// 	task: "Confirmed Orders", 
		// 	description : "View your orders under the “Confirmed” status.", 
		// 	done: startHere.data.tasks?.confirmed_orders, 
		// 	path: "/sales/product?tab=confirmed", 
		// 	condition: false, 
		// 	setter: ()=>{handleClick('productConfirmed')}
		// },
		...selected.data?.some(v => v.id === 2) ? [{
			task: "Booked Status", // BOOKING
			description : "View and update your booking under the “Booked” status.", 
			done: startHere.data.tasks?.booked_status?.done, 
			path: "/sales/booking?subft=booking&tab=1", 
			condition: true,
			isConditionMet: startHere.data.tasks?.booked_status?.enabled,
			preReq: ['If with Booked Status'],
			setter: ()=>{handleClick('bookingBooked')}
		}]: [],
		...selected.data?.some(v => v.id === 2) ? [{
			task: "Check-in Status", // BOOKING
			description : "View and update your booking under the “Checked-in” status.", 
			done: startHere.data.tasks?.check_in_status?.done,
			path: "/sales/booking?subft=booking&tab=2", 
			condition: true,
			isConditionMet: startHere.data.tasks?.check_in_status?.enabled,
			preReq: ['If with Checked-in Status'],
			setter: ()=>{handleClick('bookingCheckIn')}
		}]: [],
		// {
		// 	task: "Check-out Status", 
		// 	description : "View your booking under the “Check-out” status.", 
		// 	done: false, 
		// 	path: "/sales/booking?subft=booking&tab=3", 
		// 	condition: false,
		// 	// isConditionMet: startHere.data.tasks?.shipped_orders?.enabled,
		// 	// preReq: ['If with Orders in Shipped Status'],
		// 	setter: ()=>{handleClick('bookingCheckOut')}
		// },
		// {
		// 	task: "Weekly Sales", 
		// 	description : "Generate your sales for the week.", 
		// 	done: false, 
		// 	path: "/reports/sales?type=product",
		// 	condition: false, 
		// 	setter: ()=>{handleClick('salesProduct')}
		// },
		// {
		// 	task: "Weekly Booking Sales", 
		// 	description : "Generate your booking sales for the week.", 
		// 	done: false, 
		// 	path: "/reports/sales?type=booking", 
		// 	condition: false,
		// 	// isConditionMet: startHere.data.tasks?.shipped_orders?.enabled,
		// 	// preReq: ['If with Orders in Shipped Status'],
		// 	setter: ()=>{handleClick('salesBooking')}
		// },
		// {
		// 	task: "Training Sales", 
		// 	description : "Generate your training sales for the week.", 
		// 	done: false, 
		// 	path: "/sales/training", 
		// 	condition: false,
		// 	// isConditionMet: startHere.data.tasks?.shipped_orders?.enabled,
		// 	// preReq: ['If with Orders in Shipped Status'],
		// 	setter: ()=>{handleClick('salesTraining')}
		// },
		{
			task: "Property Inquiry", // REAL PROPERTY
			description : "View and Update your property inquiry.", 
			done: startHere.data.tasks?.property_inquiry?.done,
			path: "/lm/property-inquiries", 
			condition: true,
			isConditionMet: startHere.data.tasks?.property_inquiry?.enabled,
			preReq: ['If with Inquiry of Property'],
			setter: ()=>{handleClick('propertyInquiries')}
		},
		// {
		// 	task: "Property Agent Applications", 
		// 	description : "View and Update status of broker/agent application.", 
		// 	done: false, 
		// 	path: "/sales/real-property?type=agent-application",
		// 	condition: false,
		// 	// isConditionMet: startHere.data.tasks?.shipped_orders?.enabled,
		// 	// preReq: ['If with Orders in Shipped Status'],
		// 	setter: ()=>{handleClick('propertyAgentApplications')}
		// },
		// {
		// 	task: "Product Reviews", 
		// 	description : "Review and analyze your product reviews and rating.", 
		// 	done: false, 
		// 	path: "/reports/reviews-ratings?type=product", 
		// 	condition: false, 
		// 	setter: ()=>{handleClick('reviewProduct')}
		// },
		// {
		// 	task: "Booking Reviews", 
		// 	description : "Review and analyze your booking reviews and rating.", 
		// 	done: false, 
		// 	path: "/reports/reviews-ratings?type=service", 
		// 	condition: false, 
		// 	setter: ()=>{handleClick('reviewBooking')}
		// },
		// {
        //     task: "Onboarding Sales Product", // FOR ALL INDUSTRY
        //     description : "Create 1 creative brief of your campaign",
        //     done: false,
        //     path: "/sales/product?tab=received", 
		// 	condition: false, 
        //     setter: ()=>{handleClick('onboardingSalesProduct')}
        // },
		// {
        //     task: "Onboarding Sales Booking", // FOR ALL INDUSTRY
        //     description : "Create 1 creative brief of your campaign",
        //     done: false,
        //     path: "/sales/booking?subft=booking&tab=1", 
		// 	condition: false, 
        //     setter: ()=>{handleClick('onboardingSalesBooking')}
        // },
		// {
        //     task: "Onboarding Sales Real Property", // FOR ALL INDUSTRY
        //     description : "Create 1 creative brief of your campaign",
        //     done: false,
        //     path: "/sales/real-property?type=inquiries", 
		// 	condition: false, 
        //     setter: ()=>{handleClick('onboardingSalesRealProperty')}
        // },
	]

    // let firstTimeTask = (role === 'Admin' || role === 'Super Admin') ? adminFirstTimeTask : regularUserFirstTimeTask
	let firstTimeTask = task

    // Fetching from API for completion of First Time Tasks
    const readStatus = async()=>{
        const qsp = { 
            user_id: user_id, 
            company_id: company_id,
        }
		const res = await rqx.get(`<<tool>>/${env()}/user/read_start_personalization`, qsp)
        startHere.set((prev) => ({...prev, tasks: res}));
    }
	
    useEffect(() => {
        readStatus()
        //eslint-disable-next-line
    }, []);

    useEffect(() => {
        calculateProgress()
        //eslint-disable-next-line
    }, [startHere.data.tasks]);

    const calculateProgress = ()=>{
        const taskDone = firstTimeTask.filter(v => v.done === true)
        setProgress(Number((taskDone.length / firstTimeTask.length * 100).toFixed(2)))
    }

    const isConditionMet = (tasks, index) => {
        const condition = tasks[index]?.condition;
		if (!condition) return true
		const done = tasks[index]?.done;
		const met = tasks[index]?.isConditionMet;
		if (!done && !met) {
			return false
		} else {
			return true
		}
    };

    const getRequiredTasks = (tasks, index) => {
		const task = tasks[index]
		const reqTasks = (!task.condition || task.condition.length === 0) ? [] : task.preReq.map(c => c)
		return reqTasks
    };


    return(
        <Box>
            {(firstTimeTask.some(task => task.done === false) || startHere.data.modal) &&
                // (view === ""  ?
                    <Button 
                        sx={{ zIndex: 1300, position: 'absolute', right: 40, bottom: 30, bgcolor: '#5DB55D', boxShadow: "0px 0 71px 0px #5db55d78", borderRadius: 8, p: 2, color: "#ffff", "&:hover": {     backgroundColor: "#5DB55D",  }}}
                        onClick={()=>{startHere.set((prev) => ({...prev, modal:true}))}}
                    >
                        <Box sx={{display: "flex", gap: 1}}>
                            {startHere.data.modal ? <CloseIcon/> : <RocketLaunchOutlinedIcon/> }
                            <Typography>{startHere.data.modal ? "Close" : "Start Here"}</Typography>
                        </Box>

                    </Button>
                // :
                //     <Button 
                //         sx={{position: 'absolute', right: 15, bottom: 75, bgcolor: '#5DB55D', boxShadow: "0px 0 71px 0px #5db55d78", borderRadius: 16, p: 2, color: "#ffff", "&:hover": {     backgroundColor: "#5DB55D",  }}}
                //         onClick={()=>{startHere.set((prev) => ({...prev, modal:true}))}}
                //     >
                //         <Box sx={{display: "flex", gap: 1, alignItems: "center"}}>
                //             {startHere.data.modal ? <CloseIcon sx={{fontSize: 12}}/> : <RocketLaunchOutlinedIcon sx={{fontSize: 24}}/> }
                //             <Typography fontSize={14}>{startHere.data.modal ? "Close" : "Start Here"}</Typography>
                //         </Box>
                //     </Button>
                // )
            }
			<Modal open={startHere.data.modal} slotProps={{backdrop: {sx: { backgroundColor: "transparent" }}}} onClose={()=>{startHere.set((prev) => ({...prev, modal:false}))}} >
				<Slide in={startHere.data.modal} direction="up" >   
					<Box boxShadow="0px 8px 16px 0px #00000014;" sx={{bgcolor: "#fff", maxHeight: '70vh', width: 400, px: 3, py: 2, borderRadius: 4, position: "absolute", right: 40, bottom: 100, display: 'flex',flexDirection: 'column'}}>
						<Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}} >
							<Typography mb={1} fontWeight={600}>Start Here</Typography>
							<CloseIcon onClick={()=>{startHere.set((prev) => ({...prev, modal:false}))}} sx={{fontSize: 20}}/>
						</Box>
						<Typography fontSize={13} mb={1}>
							Complete these steps to jump start your business with HRC.
						</Typography>
						<Box sx={{display: "flex", alignItems: "center", width: "100%", gap: 2}}>
							<Typography sx={{fontWeight: 800, color: "primary.main"}}>{progress}%</Typography>
							<Box sx={{width: "100%", height: "100%"}}>
							<LinearProgress variant="determinate" value={progress} sx={{height: 10, borderRadius: 4}} />
							</Box>
						</Box>
						<Box sx={{ flex: 1, overflowY: 'auto', display: 'flex', gap: '1rem', flexDirection: 'column', my: '1rem' }}>
							{firstTimeTask.map((v, index)=>(
								<Tooltip key={index} arrow={true} disableFocusListener placement="top" sx={{bgcolor: "#003022"}} title={!isConditionMet(firstTimeTask, index) ? "Pre-requisites: \n" + getRequiredTasks(firstTimeTask, index).join("\n"): ""} slotProps={{tooltip: { sx: { whiteSpace: 'pre-line', backgroundColor: "#003022" }}, arrow: {sx:{color: "#003022"}} }}>
									<Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", gap: '8px', mr: '4px'}}>
										<Stack flex={1}>
											<Typography sx={{color: '#292C2F', fontSize: 14, fontWeight: 600}}>{v.task}</Typography>
											<Typography sx={{color: '#292C2F', fontSize: 12, fontStyle: 'italic'}}>{v.description}</Typography>
										</Stack>
										{v.done ? 
											<Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", width: 70}}>
												<Typography sx={{fontSize: 14, color: "#5DB55D"}}>Done</Typography><CheckCirleIcon sx={{color: "#5DB55D" }}/>
											</Box> 
										:
											(v.inProgress || isConditionMet(firstTimeTask, index)) ?
												<Button onClick={()=>{
													if (v.path) {
														nav.push(v.path)
													}; 
													startHere.set((prev) => ({...prev, modal:false})); 
													v.setter();
												}} sx={{bgcolor: "#e2e2e2ff", color: "#141414ff", fontSize: 14}}>{v.inProgress ? "In Progress": "Proceed"}</Button>
											:
												<Box sx={{color: '#cfcfcfff', fontSize: 14, fontWeight: 600, bgcolor: "#f7f7f7ff", p:1}}>Proceed</Box>
										}
									</Box>
								</Tooltip>
							))}
						</Box>
					</Box>
				</Slide> 
			</Modal>
        </Box>
    )
}